const configuredApiUrl = (import.meta.env.VITE_API_URL || '').trim().replace(/\/+$/, '');

/**
 * VITE_API_URL is the public backend origin, for example:
 * https://banyana.joyinnovations.net
 */
export const API_BASE_URL = configuredApiUrl
    ? (configuredApiUrl.endsWith('/api') ? configuredApiUrl : `${configuredApiUrl}/api`)
    : '/api';

export function resolveApiUrl(url) {
    let normalizedUrl = String(url);

    // Preserve local-development call sites while routing them through the
    // configured production backend.
    if (normalizedUrl.startsWith('http://localhost:5000')) {
        const localUrl = new URL(normalizedUrl);
        normalizedUrl = `${localUrl.pathname}${localUrl.search}${localUrl.hash}`;
    }

    if (normalizedUrl === '/api') {
        return API_BASE_URL;
    }

    if (normalizedUrl.startsWith('/api/')) {
        return `${API_BASE_URL}${normalizedUrl.slice('/api'.length)}`;
    }

    return normalizedUrl;
}

export default API_BASE_URL;
